import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateStreamClipMutation } from "../graphql/mutations";
import type {
  CreateStreamClipMutationType,
  CreateStreamClipMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateStreamClipMutation = (
  options?: MutationHookOptions<
    CreateStreamClipMutationType,
    CreateStreamClipMutationVariablesType
  >
) => {
  return useMutation<
    CreateStreamClipMutationType,
    CreateStreamClipMutationVariablesType
  >(CreateStreamClipMutation, options);
};
